import { getInitials } from '../helpers/string';
import type { ActiveSessionLite } from './persistedSessionHelper';
import { getAccessTypeFromMask } from './sessionAccessType';

export const getSessionDisplayData = ({
    remote: { LocalID, DisplayName, Username, PrimaryEmail, AccessType },
}: ActiveSessionLite) => {
    const nameToDisplay = DisplayName || Username || PrimaryEmail || '';
    const initials = getInitials(nameToDisplay);

    const maybeEmailInBrackets = PrimaryEmail ? `<${PrimaryEmail}>` : '';

    const path = `/u/${LocalID}`;

    return {
        localID: LocalID,
        name: nameToDisplay,
        initials,
        email: PrimaryEmail,
        maybeEmailInBrackets,
        path,
        accessType: getAccessTypeFromMask(AccessType),
    };
};
